// extracted by mini-css-extract-plugin
export default {"linking":"linking_linking__q1gHR","form":"linking_form__30T1+","ar":"linking_ar__KftRV","image":"linking_image__4O5pq"};